/* Version: 3.5.155 */
'use client';
import { TOOLTIP_SIDES } from './constants.js';

function getArrowAlignment(_ref) {
  var side = _ref.side;
  switch (side) {
    case TOOLTIP_SIDES.BOTTOM:
    case TOOLTIP_SIDES.BOTTOM_RIGHT:
    case TOOLTIP_SIDES.BOTTOM_LEFT:
      return "\n        left: calc(50% - 10px);\n        top: calc(100% + 10px);\n        transform: rotate(45deg);\n      ";
    case TOOLTIP_SIDES.TOP:
    case TOOLTIP_SIDES.TOP_RIGHT:
    case TOOLTIP_SIDES.TOP_LEFT:
      return "\n        left: calc(50% - 10px);\n        bottom: calc(100% + 6px);\n        transform: rotate(45deg);\n      ";
    case TOOLTIP_SIDES.RIGHT:
      return "\n        left: calc(100% + 6px);\n        top: 50%;\n        transform: translateY(-50%) rotate(45deg);\n      ";
    // NOTE: Our component logic prevents the default cases in this file from being reached, so we can safely ignore them from code coverage
    // istanbul ignore next
    default:
      return '';
  }
}
function getTooltipAlignment(_ref2) {
  var side = _ref2.side,
    bubbleWidth = _ref2.bubbleWidth;
  switch (side) {
    case TOOLTIP_SIDES.BOTTOM:
      return "\n        padding-top: 15px;\n        top: 100%;\n        left: calc(50% - ".concat(Math.round(bubbleWidth / 2), "px);\n      ");
    case TOOLTIP_SIDES.BOTTOM_RIGHT:
      return "\n        padding-top: 15px;\n        top: 100%;\n        left: -20px;\n      ";
    case TOOLTIP_SIDES.BOTTOM_LEFT:
      return "\n        padding-top: 15px;\n        top: 100%;\n        right: -20px;\n      ";
    case TOOLTIP_SIDES.TOP:
      return "\n        padding-bottom: 10px;\n        bottom: 100%;\n        left: calc(50% - ".concat(Math.round(bubbleWidth / 2), "px);\n      ");
    case TOOLTIP_SIDES.TOP_RIGHT:
      return "\n        padding-bottom: 10px;\n        bottom: 100%;\n        left: -20px;\n      ";
    case TOOLTIP_SIDES.TOP_LEFT:
      return "\n        padding-bottom: 10px;\n        bottom: 100%;\n        right: -20px;\n      ";
    case TOOLTIP_SIDES.RIGHT:
      return "\n        padding-left: 10px;\n        left: 100%;\n        top: 50%;\n        transform: translateY(-30px);\n      ";
    // istanbul ignore next
    default:
      return '';
  }
}

export { getArrowAlignment, getTooltipAlignment };
